import templateUrl from './app-toolbar.html';

export default {
  templateUrl,
  transclude: {
    toolbarButtonsLeft: 'toolbarButtonsLeft',
    toolbarButtonsRight: 'toolbarButtonsRight'
  },
  controller: class ToolbarComponent {
    constructor() {
      'ngInject';
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/app-toolbar/app-toolbar.component.js